import { render, staticRenderFns } from "./workOverList.vue?vue&type=template&id=8964eae6&scoped=true&"
import script from "./workOverList.vue?vue&type=script&lang=js&"
export * from "./workOverList.vue?vue&type=script&lang=js&"
import style0 from "./workOverList.vue?vue&type=style&index=0&id=8964eae6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8964eae6",
  null
  
)

export default component.exports